import React from 'react';
import { Translate } from 'core/translate';
import { invert } from './utils';
import { SecondaryLine, TotalLine } from './Lines';
import MathBoxGroup from './MathBoxGroup';

const TotalPriceAndDiscountsGroup = ({
  pricing,
  eventName,
  ruled,
  isUnitedStates
}) => {
  const { totalMsrp, eventDiscount, incentives, isSeeDealer } = pricing;

  if (isSeeDealer) {
    return null;
  }

  if (isUnitedStates && pricing.employeePrice) {
    return (
      <MathBoxGroup ruled={ruled}>
        <TotalLine labelKey="total.vehicle.price" value={totalMsrp} />
      </MathBoxGroup>
    );
  }

  return (
    <MathBoxGroup ruled={ruled}>
      <TotalLine labelKey="total.vehicle.price" value={totalMsrp} />
      <SecondaryLine
        labelKey="total.cash.allowances"
        value={invert(incentives.value)}
      />
      <SecondaryLine
        label={<Translate value="event.discount" eventName={eventName} />}
        value={invert(eventDiscount)}
      />
    </MathBoxGroup>
  );
};

export default TotalPriceAndDiscountsGroup;
